import classNames from "classnames";
import { useTranslation } from "react-i18next";

export type PropLibraryScope = "props" | "situations";

interface PropLibraryScopeSwitcherProps {
  value: PropLibraryScope;
  onChange: (scope: PropLibraryScope) => void;
}

/**
 * The labelled Props/Situations switch in the search row. Labelled, not
 * icon-only, on the same grounds as the multi-select decision: these are two
 * different data sets, and a bare icon would change meaning when toggled.
 */
export default function PropLibraryScopeSwitcher(
  props: PropLibraryScopeSwitcherProps
) {
  const { value, onChange } = props;
  const { t } = useTranslation();

  const option = (scope: PropLibraryScope, label: string) => (
    <button
      type="button"
      aria-pressed={value === scope}
      onClick={() => onChange(scope)}
      className={classNames(
        "px-[10px] h-[22px] rounded-[4px] text-[12px] leading-none transition-colors",
        value === scope
          ? "bg-creator-surface border border-creator-border text-creator-text font-medium"
          : "text-creator-text-sub hover:bg-creator-childActive"
      )}
    >
      {label}
    </button>
  );

  return (
    <div className="flex items-center gap-[2px] p-[2px] rounded-[6px] border border-creator-border">
      {option("props", t("prop_library_ui.scope_props"))}
      {option("situations", t("prop_library_ui.scope_situations"))}
    </div>
  );
}
